import { calendarApi } from './calendar';
import { createHttp, type GraphOptions } from './core';
import { mailboxSettingsApi, peopleApi } from './directory';
import { mailApi } from './mail';

export * from './core';
export type { Attachment, DraftInput, MailMessage, MailSummary, Recipient } from './mail';
export type { CalendarEvent, EventInput } from './calendar';
export type { MailboxSettings, Person } from './directory';

/** Client Graph mỏng cho Box: mail · calendar · mailboxSettings · people. Lỗi → `GraphError` (`kind: 'noperm'` ⇒ trạng thái `noperm`). */
export function createGraph(o: GraphOptions) {
  const h = createHttp(o);
  return { mail: mailApi(h), calendar: calendarApi(h), mailboxSettings: mailboxSettingsApi(h), people: peopleApi(h) };
}
export type Graph = ReturnType<typeof createGraph>;
